import React from "react";

// const PDF_URL =
// "https://api.qureal.com/assets/dba04c0f-f64a-4f4f-9e6d-f29417805705";
const PDF_URL = "https://api.qureal.com/assets/";

function QPDFEmbeded({ input, pageStyle }) {
    return (
        <div>
            <iframe
                // src={PDF_URL}
                src={`${PDF_URL}${input.pdfFile?.params?.id}`}
                width="100%"
                height="500"
                align="center"
                title="PDF Viewer"
            ></iframe>
        </div>
    );
}

export default QPDFEmbeded;
